import { createMap, IOmniaSettings, isArrayEmpty } from "../omnia"
import { IAnalysisValueColumn } from "../types"

export const getDefaultColumns = (): IAnalysisValueColumn[] => [

    { name: "P2O5", units: "ppm", header: "P<sub>2</sub>O<sub>5</sub>", index: true, selectable: true, gauge: true, visible: true, morgan: true },
    { name: "P2O5Method", header: "P<sub>2</sub>O<sub>5</sub> Method", index: true },
    { name: "K2O", units: "ppm", header: "K<sub>2</sub>O", index: true, selectable: true, gauge: true, visible: true, morgan: true },
    { name: "MgO", units: "ppm", index: true, selectable: true, gauge: true, visible: true, morgan: true },
    { name: "WaterpH", header: "pH", key: "pH", selectable: true, gauge: true, visible: true },

    { name: "SoilCEC", units: "meq/100g", header: "Soil CEC", key: "SoilCEC" },
    { name: "OrganicMatter", units: "%", header: "Organic Matter", key: "OrganicMatter" },
    { name: "Sand", units: "%", header: "Sand", key: "Sand" },
    { name: "Silt", units: "%", header: "Silt", key: "Silt" },
    { name: "Clay", units: "%", header: "Clay", key: "Clay" },

    { name: "Boron", units: "ppm", header: "Boron", key: "Boron" },
    { name: "CaO", units: "ppm", header: "Calcium", key: "CaO" },
    { name: "Copper", units: "ppm", header: "Copper", key: "Copper" },
    { name: "Iron", units: "ppm", header: "Iron", key: "Iron" },
    { name: "Molybdenum", units: "ppm", header: "Molybdenum", key: "Molybdenum" },
    { name: "Sodium", units: "ppm", header: "Sodium", key: "Sodium" },
    { name: "SO3", units: "ppm", header: "Sulphur", key: "SO3" },
    { name: "Zinc", units: "ppm", header: "Zinc", key: "Zinc" },
    { name: "Manganese", units: "ppm", header: "Manganese", key: "Manganese" },

    { name: "TotalP2O5", units: "kg/ha", header: "Total P<sub>2</sub>O<sub>5</sub>" },
    { name: "TotalK2O", units: "kg/ha", header: "Total K<sub>2</sub>O" },
    { name: "TotalMgO", units: "kg/ha", header: "Total MgO" },
    { name: "TotalCaO", units: "kg/ha", header: "Total CaO" },

    { name: "SoilHealthIndex", units: "", header: "Soil health index" },
    { name: "CO2BurstIndex", units: "", header: "CO<sup>2</sup> burst index" },
    { name: "CO2Burst", units: "mg/kg", header: "CO<sup>2</sup> burst" }

]

const settingName = "soilDashboardColumnsDefinitionsv2"

export function restoreColumns(settings: IOmniaSettings): IAnalysisValueColumn[] {

    const def = getDefaultColumns()

    let s = settings.get(settingName) as IAnalysisValueColumn[]

    if (isArrayEmpty(s)) {
        return def
    }

    // TODO: should probably only serialise visible columns, and only their names/ids at that

    const map = createMap(def, d => d.name)

    s = s.map(d => {

        const a = map.get(d.name)
        if (!a) return

        return {
            ...d,
            morgan: a.morgan,
            index: a.index,
            units: a.units
        }

    }).filter(c => !!c)


    return s

}

export function saveColumns(settings: IOmniaSettings, columns: IAnalysisValueColumn[]) {
    settings.set(settingName, columns)
}
